import React from "react";
import { cn } from "../../utils/cn";

const supportedStatuses = new Set([
  "draft",
  "submitted",
  "needs_review",
  "reconciled",
  "closed",
]);

function normalizeStatus(status) {
  const normalized = String(status || "draft").trim().toLowerCase();
  return supportedStatuses.has(normalized) ? normalized : "draft";
}

function statusKey(status) {
  return `regionalHealthSignals.status.${status.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())}`;
}

/**
 * The sole visual status contract for Institution Regional Health records.
 * The caller owns localisation; this component owns the semantic status tone.
 */
export default function RegionalHealthStatusChip({ status, t, className }) {
  const normalizedStatus = normalizeStatus(status);
  const label = t?.(statusKey(normalizedStatus), normalizedStatus) || normalizedStatus;

  return (
    <span
      className={cn(
        "afrimed-regional-health-status-chip",
        `afrimed-regional-health-status-chip--${normalizedStatus}`,
        className,
      )}
    >
      {label}
    </span>
  );
}

export { normalizeStatus as normalizeRegionalHealthStatus };
